import axiosPost from '../axiosPost';

export const conciliacionesAcreditar = async (arg) => {
    const { ids } = arg

    const body = {
        "service": "BindConciliacionCashInDo",
        "params": {
            "bindConciliacionOperacionIds": ids
        }
    }

    try {
        const result = await axiosPost('Y', body, arg);
        console.log(body, result.data);
        return result.data
    }
    catch (err) {
        console.log(err)
    };
};